<template lang="pug">
.email(
  :class="{ 'email--submitted': !plain && completed }"
  :id="`email_${id}`"
  :data-id="id"
  v-if="!audioDoc"
)
  .email__main.rounded.overflow-hidden.shadow-xl.fade-in
    .email__window-bar.bg-gray-500.text-white.text-center.text-sm.tracking-wider.p-1(
      aria-hidden="true"
      uc-word-skip=""
    )
      uc-text(:k="`${id}.email.subject`" :text="subject")
    .email__outlook-ribbon
    .email__window.bg-white.pt-6.pb-12.px-6.lg_px-12.relative
      .email__subject.prose-2xl.font-thin.mb-3
        p
          uc-text.sentence__text(:k="`${id}.email.subject`" :text="subject")

      .email__from.border-gray-200.border-2.border-l-0.border-r-0.flex.py-3
        .email__avatar.w-12.h-12.bg-secondary-600.text-white.flex.items-center.justify-center.text-xl.tracking-wider.font-light.rounded-full.me-4(
          aria-hidden="true"
          uc-word-skip=""
        )
          uc-text(:text="initials")

        .email__name.prose-sm
          label.email__from-address(
            :class="{ '-bold': 0 && from.flag }"
            :data-flag="from.flag ? 1 : 0"
          )
            input.sr-only(
              :checked="suspend?.questionOptions?.[`${id}_from`]"
              :data-sfx="suspend?.questionOptions?.[`${id}_from`] ? 'highlight_undo' : 'highlight'"
              :disabled="suspend.completed[id] || !from.flag"
              :id="`${id}_from`"
              @change="updateSentence"
              type="checkbox"
              uc-word-skip=""
              v-if="!plain"
            )
            span.sentence__flag(v-if="from.flag")
              transition-pop
                uc-icon.text-color.absolute.right-0.inline.mx-2.md_mx-3.my-0.text-2xl.text-primary-600(
                  icon="mdi:flag-variant"
                  v-if="from.flag && completed"
                )
            span(
              :class="{ 'sentence__text': from.flag }"
            )
              span.inline-block(
                :class="[{ 'select-text cursor-auto': plain }, { 'sentence__highlight': from.flag }]"
                :uc-word-bold="from.flag || null"
              )
                uc-text(text="From:") 
                | #{ ' ' }
                uc-text(:k="`${id}.from`" :text="fromText")

          .email__date
            uc-text(:text="date")
      .email__attachment_wrapper.border-gray-200.border-b-2.py-3.flex.flex-wrap.gap-2(
        v-if="attachments"
      ) 
        .email__attachment(
          :key="attachment.filename"
          v-for="attachment in attachments"
        )
          label.email__paragraph(
            :class="{ '-bold': 0 && attachment.flag }"
            :data-flag="attachment.flag ? 1 : 0"
            :key="attachment.filename"
          )
            input.sr-only(
              :checked="suspend?.questionOptions?.[`${id}_${escapeFilename(attachment.filename)}`]"
              :data-sfx="suspend?.questionOptions?.[`${id}_${escapeFilename(attachment.filename)}`] ? 'highlight_undo' : 'highlight'"
              :disabled="suspend.completed[id]"
              :id="`${id}_${escapeFilename(attachment.filename)}`"
              @change="updateSentence"
              type="checkbox"
              uc-word-skip=""
              v-if="!plain"
            )
            span.sentence__flag
              transition-pop
                uc-icon.text-color.absolute.right-0.inline.mx-2.md_mx-3.my-0.text-2xl.text-primary-600(
                  icon="mdi:flag-variant"
                  v-if="attachment.flag && completed"
                )
            span.sentence__text.flex.flex-row.flex-1
              span.sentence__highlight.inline-block.border-gray-200(
                :class="{ 'select-text cursor-auto': plain }"
                :uc-word-bold="attachment.flag || null"
              )
                .email__download.inline-flex.gap-3.p-2
                  uc-icon.text-3xl.justify-self-center.self-center(
                    icon="teenyicons:attachment-outline"
                  )
                  .col-span-3.text-gray-500.text-sm.mr-6.flex.flex-col 
                    span {{ attachment.filename }}
                    span {{ attachment.filesize }}
                  uc-icon.justify-self-center.self-center(
                    icon="codicon:triangle-down"
                  )
      .email__body.prose-lg.max-w-none.mt-6.pe-4.lg_pe-0
        p.email__paragraph(:key="i" v-for="(p, i) in body")
          label.sentence(
            :class="{ '-bold': 0 && s.flag, 'text-center block': s.center }"
            :data-flag="s.flag ? 1 : 0"
            :key="j"
            v-for="(s, j) in p"
          )
            uc-preload-sfx(name="highlight_undo")
            uc-preload-sfx(name="highlight")
            input.sr-only(
              :checked="suspend?.questionOptions?.[`${id}_${i}_${j}`]"
              :data-sfx="suspend?.questionOptions?.[`${id}_${i}_${j}`] ? 'highlight_undo' : 'highlight'"
              :disabled="suspend.completed[id]"
              :id="`${id}_${i}_${j}`"
              @change="updateSentence"
              type="checkbox"
              uc-word-skip=""
              v-if="!plain"
            )
            span.sentence__flag
              transition-pop
                uc-icon.text-color.absolute.right-0.inline.mx-2.md_mx-3.my-0.text-2xl.text-primary-600(
                  icon="mdi:flag-variant"
                  v-if="s.flag && completed"
                )
            span.sentence__text 
              span.sentence__highlight(
                :class="{ 'select-text cursor-auto': plain, 'inline-block': s.img }"
                :uc-word-bold="s.flag || null"
              )
                uc-asset.h-fit.m-0(
                  :size="s['img-size'] || 8"
                  :src="s.img"
                  v-if="s.img"
                )
                uc-text(
                  :class="{ sentence__link: s.link }"
                  :k="s.text ? `${s.id}.text` : `${s.id}.link`"
                  :text="s.text || s.link"
                  v-else=""
                )
            span(uc-word-only="" aria-hidden="true") &nbsp;

      transition-expand
        uc-button.mt-10.btn.btn-primary.ripple.email__submit.w-full.sm_w-auto(
          :class="[completed ? 'auto-alpha-0 scale-0' : 'auto-alpha-1 scale-1']"
          :disabled="!enableSubmit"
          @click="submit"
          type="button"
          v-if="!plain && !completed"
        )
          span.ripple__wave
          uc-text(text="Submit")
  .email__feedback.fade-in(
    aria-live="polite"
    aria-atomic="true"
    role="status"
  )
    transition-expand
      .feedback.mt-10(v-if="!plain && completed")
        uc-editable.mx-auto(
          :editPath="`${editPath}.email.feedback`"
          :k="`${this.id}.email.feedback`"
          :text="feedback"
      )

//- process email feedback for the audio script
.feedback-audio(v-if="audioDoc")
  audio-marker(:name="`${this.id}-email-feedback`")
  uc-text(
    :k="`${this.id}.email.feedback`"
    :text="feedback"
  )
</template>

<script lang="ts">
import { inject, computed, toRef } from 'vue';
import { setCompleted, set } from '../lib/SCORM';
import useQuizzes from '../stores/useQuizzes';
import useScreenAudio, { type NarratableScreen } from '../lib/useScreenAudio';
import { schemaForTemplate } from '../lib/screen-schemas';
import isQuizPage from '../lib/isQuizPage';
import languagesData from '../lib/languages.json';

export default {
  inject: ['suspend', 'sectionId', 'audioDoc'],
  props: {
    editPath: { type: String, required: false },
    screen: { type: Object, required: true },
    plain: { type: Boolean, default: false }
  },
  setup(props) {
    const screenRef = toRef(props, 'screen');
    const schema = computed(() =>
      schemaForTemplate(
        (screenRef.value as NarratableScreen).template as string | undefined
      )
    );
    const { playSlot } = useScreenAudio(screenRef, schema);

    const morning = new Date(new Date().toISOString().split('T')[0]).setHours(
      8
    );
    const yesterday = morning - 24 * 60 * 60 * 1000 + 36e6 * Math.random();

    return { playSlot, yesterday };
  },
  data() {
    const pageId = inject('pageId') as object;
    const { register } = useQuizzes();

    register(this.screen, pageId);

    return {
      to: this.screen.email.to,
      from: this.screen.email.from,
      fromText: this.screen.email.from.text || this.screen.email.from,
      subject: this.screen.email.subject,
      body: this.screen.email.body,
      id: this.screen.id,
      feedback: this.screen.email.feedback,
      logo: this.screen.email.logo,
      size: this.screen.email['img-size'],
      attachments: this.screen.email.attachments,
      pageId: pageId
    };
  },
  mounted() {
    const app = document.querySelector('#app');
    app?.addEventListener('quizReset', async e => {
      if (await isQuizPage(e, this.pageId)) this.resetAll();
    });
  },
  computed: {
    completed() {
      return this.suspend.completed[this.id];
    },
    enableSubmit() {
      return this.screen['min-select-count']
        ? this.selectedCount() >= this.screen['min-select-count']
        : true;
    },
    initials() {
      // Handle cases where initials are already provided (e.g. "J.W. email@domain.com")
      if (this.fromText.match(/^[A-Z]\.[A-Z]\./i)) {
        return this.fromText
          .split('.')
          .slice(0, 2)
          .map(i => i.trim().toUpperCase())
          .join('');
      }

      // Handle normal names (e.g. "First Last email@domain.com")
      const parts = this.fromText.split(' ');
      const nameWords = parts.filter(word => !word.includes('@')); // Filter out email addresses

      if (nameWords.length >= 2) {
        // If we have at least 2 name parts, take first and last
        return (nameWords[0][0] + nameWords[1][0]).toUpperCase();
      } else if (nameWords.length === 1) {
        // If only one name part, use first letter of first word
        return nameWords[0][0].toUpperCase();
      } else {
        // If no separate name words:
        // - return the first A-Z character of the from text before the @ (e.g. \<email@domain.com\> => E)
        // - if no A-Z character, return '@'
        const match = this.fromText.match(/[A-Za-z](?=.*@)/);
        return match?.[0]?.toUpperCase() || '@';
      }
    },
    date() {
      const languages = this.getLanguages();
      const validLocale = languages.some(
        lang => lang.code === this.suspend.locale
      );
      const fallbackLocale = navigator.language || 'en-GB';
      return new Date(this.yesterday).toLocaleString(
        validLocale ? this.suspend.locale : fallbackLocale,
        { dateStyle: 'full', timeStyle: 'short' }
      );
    },
    allCorrect() {
      let result = true;
      // check if all sentences are correct
      for (const paragraph in this.body) {
        for (const sentence in this.body[paragraph]) {
          const isSelectedAndIncorrect =
            this.suspend?.questionOptions?.[
              `${this.screen.id}_${paragraph}_${sentence}`
            ] && this.body[paragraph][sentence].flag === 0;
          const isNotSelectedAndCorrect =
            !this.suspend?.questionOptions?.[
              `${this.screen.id}_${paragraph}_${sentence}`
            ] && this.body[paragraph][sentence].flag === 1;
          if (isSelectedAndIncorrect || isNotSelectedAndCorrect) {
            result = false;
          }
        }
      }
      // check if all attachments are correct
      for (const i in this.attachments) {
        const isSelectedAndIncorrect =
          this.suspend?.questionOptions?.[
            `${this.screen.id}_${this.escapeFilename(
              this.attachments[i].filename
            )}`
          ] && this.attachments[i].flag === 0;
        const isNotSelectedAndCorrect =
          !this.suspend?.questionOptions?.[
            `${this.screen.id}_${this.escapeFilename(
              this.attachments[i].filename
            )}`
          ] && this.attachments[i].flag === 1;
        if (isSelectedAndIncorrect || isNotSelectedAndCorrect) {
          result = false;
        }
      }

      // check if from address is correct
      const isSelectedAndIncorrect =
        this.suspend?.questionOptions?.[`${this.screen.id}_from`] &&
        this.from.flag === 0;
      const isNotSelectedAndCorrect =
        !this.suspend?.questionOptions?.[`${this.screen.id}_from`] &&
        this.from.flag === 1;
      if (isSelectedAndIncorrect || isNotSelectedAndCorrect) {
        result = false;
      }

      return result;
    }
  },

  methods: {
    updateSentence(e) {
      set(`questionOptions.${e.currentTarget.id}`, e.target.checked);
    },
    selectedCount() {
      let count = 0;
      const body = this.screen.email.body;
      for (const paragraph in body) {
        for (const sentence in body[paragraph]) {
          if (
            this.suspend?.questionOptions?.[
              `${this.screen.id}_${paragraph}_${sentence}`
            ]
          ) {
            count++;
          }
        }
      }

      for (const i in this.attachments) {
        if (
          this.suspend?.questionOptions?.[
            `${this.screen.id}_${this.escapeFilename(
              this.attachments[i].filename
            )}`
          ]
        ) {
          count++;
        }
      }

      if (this.suspend?.questionOptions?.[`${this.screen.id}_from`]) {
        count++;
      }
      return count;
    },
    submit() {
      setCompleted(this.id);
      setCompleted(this.sectionId);
      set(`correctQuestions.${this.id}`, this.allCorrect);

      if (this.feedback) this.playSlot('email-feedback');
    },
    escapeFilename(filename: string) {
      return filename.replace(/\.+/g, '_');
    },
    resetAll() {
      for (const paragraph in this.body) {
        for (const sentence in this.body[paragraph]) {
          set(
            `questionOptions.${this.screen.id}_${paragraph}_${sentence}`,
            false
          );
        }
      }
      // check if all attachments are correct
      for (const i in this.attachments) {
        set(
          `questionOptions.${this.screen.id}_${this.escapeFilename(
            this.attachments[i].filename
          )}`,
          false
        );
      }

      // check if from address is correct
      set(`questionOptions.${this.screen.id}_from`, false);
    },
    getLanguages() {
      const languages = Object.keys(languagesData)
        .filter(code => !languagesData[code].deprecated)
        .map(code => ({
          code,
          ...languagesData[code]
        }));
      return languages;
    }
  }
};
</script>

<style>
.email__paragraph {
  line-height: 1.5;
}

.sentence__link {
  color: blue;
  text-decoration: underline;
}

.sentence__text {
  border: 0.2em solid transparent;
  box-decoration-break: clone;
  margin: -0.2em;
  padding: 0 0.1em;
  @apply font-sans;
}

.sentence__highlight {
  border-radius: 3px;
  box-decoration-break: clone;
  border: 2px solid transparent;
  @apply transition-all;

  padding: 0 1px;
  margin: 0 -2px;
  margin-right: 0.2ch;
  user-select: none;

  --bg-h: 0;
  --bg-o: 1;
  --bg-h-2: 100%;
  --bg-o-2: 0.25;

  --color: var(--color-primary-500);

  background:
    linear-gradient(
        90deg,
        rgb(var(--color) / var(--bg-o)),
        rgb(var(--color) / var(--bg-o))
      )
      no-repeat left bottom / 0 var(--bg-h),
    linear-gradient(
        90deg,
        rgb(var(--color) / var(--bg-o-2)),
        rgb(var(--color) / var(--bg-o-2))
      )
      no-repeat left bottom / 0 var(--bg-h-2);

  transition: background-size 350ms;

  input:not([disabled]) ~ span:hover > & {
    @apply border-primary-600/50;
    cursor: pointer;
  }

  input:checked ~ span > & {
    background-size:
      100% var(--bg-h),
      100% var(--bg-h-2);
    background-position-x: left, left;
    border-color: rgb(var(--color) / var(--bg-o-2));
    @apply text-primary-900;

    img {
      mix-blend-mode: multiply;
    }
  }
}

.email--submitted [data-flag='0'] .sentence__highlight {
  filter: saturate(0);
  color: black;
  opacity: 0.5;
}

.email--submitted [data-flag='1'] .sentence__highlight {
  border-color: rgb(var(--color) / 1);
}
</style>
